import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export function transactionReducer(state, action) {
  var _a, _b;
  switch (action.type) {
    case 'ADD_TRANSACTION':
      {
        var chainId = action.payload.transaction.chainId;
        return Object.assign(Object.assign({}, state), _defineProperty({}, chainId, [action.payload].concat(_toConsumableArray((_a = state[chainId]) !== null && _a !== void 0 ? _a : []))));
      }
    case 'UPDATE_TRANSACTION':
      {
        var _action$payload$trans = action.payload.transaction,
          _chainId = _action$payload$trans.chainId,
          hash = _action$payload$trans.hash;
        return Object.assign(Object.assign({}, state), _defineProperty({}, _chainId, ((_b = state[_chainId]) !== null && _b !== void 0 ? _b : []).map(function (tx) {
          return tx.transaction.hash === hash ? Object.assign(Object.assign({}, tx), action.payload) : tx;
        })));
      }
    case 'UPDATE_TRANSACTIONS':
      return Object.assign(Object.assign({}, state), _defineProperty({}, action.chainId, _toConsumableArray(action.transactions)));
  }
}